import { useEffect, useState } from "react";
import { PLANS } from "@/lib/brand";
import { fetchPlans } from "@/lib/api";

export const usePlans = () => {
  const [plans, setPlans] = useState(PLANS);
  useEffect(() => {
    let alive = true;
    fetchPlans().then((d) => { if (alive && d.length) setPlans(d); });
    return () => { alive = false; };
  }, []);
  return plans;
};

export const POPULAR_PID = "2";
